/* @ngInject */
const myPhonesCreate = (
  utils,
  valueHandler,
  toaster,
  $$phone
) => {
  return {
    restrict: 'E',
    scope: {
      myPhones: '=',
      id: '@myId',
    },

    template: require('./myPhonesCreate.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.addPhone = () => {
        $scope.myPhones.push($$phone.new())
      }

      $scope.removePhone = async (_index) => {
        const id = $scope.myPhones[_index].id
        if (valueHandler.isId(id)) {
          try {
            await $$phone.request.delete(id)
            $scope.myPhones.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.myPhones.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myPhonesCreate



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/directives/myPhonesCreate.js